import { registerLocaleData } from '@angular/common'
import localeFr from '@angular/common/locales/fr'
// Angular
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, NavigationStart, Router } from '@angular/router'
import { fromEvent, Observable, Subscription } from 'rxjs'
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from './core/_base/layout'
import { locale as frLang } from './core/_config/i18n/fr'
import { StateService } from './services'


@Component({
	selector: 'body[atyl-root]',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
	// Public properties
	title = 'Atyl AssMat';
	loader: boolean
	private readonly unsubscribe: Subscription[] = []
	offlineEvent: Observable<Event>
	onlineEvent: Observable<Event>

	/**
	 * Component constructor
	 *
	 * @param translationService: TranslationService
	 * @param router: Router
	 * @param layoutConfigService: LayoutCongifService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(private readonly translationService: TranslationService,
		private readonly router: Router,
		private readonly layoutConfigService: LayoutConfigService,
		private readonly splashScreenService: SplashScreenService,
		private readonly stateService: StateService
	) {
		registerLocaleData(localeFr, 'fr')
		// register translations
		this.translationService.loadTranslations(frLang)
		this.translationService.setLanguage('fr')

	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		// enable/disable loader
		this.loader = this.layoutConfigService.getConfig('loader.enabled')

		const routerSubscription = this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// hide splash screen
				this.splashScreenService.hide()

				// scroll to top on every route change
				window.scrollTo(0, 0)
			}
		})
		this.unsubscribe.push(routerSubscription)
		this.handleAppConnectivityChanges()
	}


	private handleAppConnectivityChanges(): void {
		this.onlineEvent = fromEvent(window, 'online')
		this.offlineEvent = fromEvent(window, 'offline')

		this.unsubscribe.push(this.onlineEvent.subscribe(e => {
			// handle online mode
			this.stateService.updateOnline(true)
		}))

		this.unsubscribe.push(this.offlineEvent.subscribe(e => {
			// handle offline mode
			this.stateService.updateOnline(false)
		}))
	}
	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.unsubscribe.forEach(sb => sb.unsubscribe())
	}
}
